import { Badge } from '@signozhq/ui/badge';

export default function BetaTag(): JSX.Element {
	return <Badge color="robin">Beta</Badge>;
}
